import { defineMessages } from 'react-intl'

export default defineMessages({
    addressLabel: {
        defaultMessage: 'Dirección de la plaza de garaje',
    },
    addressPlaceholder: {
        defaultMessage: '¿Dónde está tu garaje?',
    },
    requiredError: {
        defaultMessage: 'Obligatorio',
    },
    lengthError: {
        defaultMessage: 'La dirección debe contener como máximo 100 caracteres.',
    },
})
